var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useMemo, useState, useEffect, } from 'react';
import uniqueId from 'lodash.uniqueid';
import styled from '../../utils/styled-components';
import useDebounce from '../../hooks/useDebounce';
import { ErrorMessage } from '../Input/ErrorMessage';
import Label from '../Label';
import InputHint from '../Input/InputHint';
import formTheme from '../theme';
import { ComponentThemeProvider } from '../../ThemeProvider';
import { Grid, Cell } from '../../Grid';
import { PasswordLength } from '../Input/BasicInput';
var getLevel = function (error) { return (error ? 'error' : 'normal'); };
var StyledTextarea = styled.textarea(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  min-width: 100%;\n  max-width: 100%;\n  min-height: 6.25rem;\n  font-size: ", ";\n  padding: ", ";\n  color: ", ";\n  overflow: auto;\n  line-height: 1.125rem;\n  background-color: #fff;\n  border: 0px none;\n  outline: 0;\n  border-radius: ", ";\n  ", ";\n  &:focus,\n  &:active {\n    ", ";\n  }\n  &:disabled {\n    box-shadow: inset 0 0 0 1px ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n"], ["\n  width: 100%;\n  min-width: 100%;\n  max-width: 100%;\n  min-height: 6.25rem;\n  font-size: ", ";\n  padding: ", ";\n  color: ", ";\n  overflow: auto;\n  line-height: 1.125rem;\n  background-color: #fff;\n  border: 0px none;\n  outline: 0;\n  border-radius: ", ";\n  ",
    ";\n  &:focus,\n  &:active {\n    ",
    ";\n  }\n  &:disabled {\n    box-shadow: inset 0 0 0 1px ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n"])), function (_a) {
    var component = _a.theme.component;
    return component.form.fontSize.small;
}, function (_a) {
    var component = _a.theme.component;
    return component.form.textarea.padding;
}, function (_a) {
    var component = _a.theme.component;
    return component.form.textColor.normal;
}, function (_a) {
    var component = _a.theme.component;
    return component.form.borderRadius;
}, function (_a) {
    var component = _a.theme.component, error = _a.error, isFilled = _a.isFilled;
    return "box-shadow: inset 0 0 0 " + (error ? '2px' : '1px') + " " + (isFilled && !error
        ? component.form.borderColor.normal
        : component.form.borderColor[getLevel(error)]) + ";";
}, function (_a) {
    var component = _a.theme.component, error = _a.error, isFilled = _a.isFilled;
    return "box-shadow: inset 0 0 0 " + (error ? '2px' : '1px') + " " + (isFilled && !error
        ? component.form.borderColor.active
        : component.form.borderColor[getLevel(error)]) + ";";
}, function (_a) {
    var component = _a.theme.component;
    return component.form.borderColor.disabled;
}, function (_a) {
    var component = _a.theme.component;
    return component.form.backgroundColor.disabled;
}, function (_a) {
    var component = _a.theme.component;
    return component.form.textColor.disabled;
});
/**
 * Renders a Textarea with the given settings
 */
var Textarea = function (props) {
    var label = props.label, error = props.error, id = props.id, valid = props.valid, children = props.children, placeholder = props.placeholder, inputRef = props.inputRef, inputHint = props.inputHint, onChange = props.onChange, disabled = props.disabled, lengthMinMax = props.lengthMinMax, displayLength = props.displayLength;
    var _a = useState(0), length = _a[0], setLength = _a[1];
    var debouncedChildren = useDebounce(children, 1000);
    var maxlength = lengthMinMax !== undefined && lengthMinMax[1] !== undefined ? lengthMinMax[1] : undefined;
    var componentId = useMemo(function () {
        return !id ? uniqueId() : id;
    }, [id]);
    useEffect(function () {
        setLength(debouncedChildren !== undefined ? debouncedChildren.length : 0);
    }, [debouncedChildren]);
    return (React.createElement(ComponentThemeProvider, { theme: formTheme },
        React.createElement(React.Fragment, null,
            (label || displayLength) && (React.createElement(Grid, { cellsPerRow: [2] },
                React.createElement(Cell, null, label && React.createElement(Label, { htmlFor: componentId }, label)),
                React.createElement(Cell, null, displayLength && React.createElement(PasswordLength, { lengthMinMax: lengthMinMax, length: length })))),
            React.createElement(StyledTextarea, { error: Boolean(error), id: componentId, rows: 4, valid: valid, placeholder: placeholder, ref: inputRef, isFilled: length > 0, disabled: disabled, maxLength: maxlength, onChange: function (event) {
                    setLength(event.currentTarget.value.length);
                    if (onChange) {
                        onChange(event);
                    }
                } }, children),
            error && React.createElement(ErrorMessage, { error: error }),
            !error && inputHint && React.createElement(InputHint, { disabled: Boolean(disabled), message: inputHint }))));
};
export default Textarea;
var templateObject_1;
//# sourceMappingURL=index.js.map